<template>
  <div>
    <nav class="navbar navbar-transparent navbar-absolute">
      <div class="container">
        <div class="navbar-header">
          <button type="button"
                  class="navbar-toggle navbar-toggle-black"
                  @click="toggleNavbar"
                  data-toggle="collapse"
                  data-target="#navigation-example-2">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar "></span>
            <span class="icon-bar "></span>
            <span class="icon-bar"></span>
          </button>
        </div>
        <div class="collapse navbar-collapse">
          <ul class="nav navbar-nav navbar-right">
            <li>
              <router-link to="/scan" class="btn">
                Scan Code
              </router-link>
            </li>
            <li>
              <a href="https://authentic.net" class="btn">
                Home
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <div class="wrapper wrapper-full-page">
      <div class="register-page">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-8 col-md-offset-2">
                <div class="header-text">
                  <h2>Authentic.net</h2>
                  <h4>Have a product with an Authentic.net code? Check your code below!</h4>
                  <hr>
                </div>
              </div>
              <div class="col-md-4 col-md-offset-2">
                <div class="media">
                  <div class="media-left">
                    <div class="icon icon-danger">
                      <i class="ti ti-lock"></i>
                    </div>
                  </div>
                  <div class="media-body">
                    <h5>Check Your Product</h5>
                    Submit your Authentic.net Code to check the validity of your product.
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <form method="#" action="#" @submit.prevent="validateBeforeSubmit()">
                  <div class="card card-plain">
                    <div class="content">
                      <div class="form-group">
                        <input
                          type="text"
                          name="code"
                          v-model="model.code"
                          v-validate="modelValidations.code"
                          placeholder="Authentic.net Code"
                          class="form-control">
                        <small class="text-danger" v-show="code.invalid">
                          {{ getError('code') }}
                        </small>
                      </div>
                    </div>
                    <div class="footer text-center">
                      <button type="button" v-show="!loading" @click.prevent="" class="btn btn-fill btn-danger btn-wd" ref="btnSubmit" id="validate-submit">Submit</button>
                      <button type="button" v-show="loading" class="btn btn-wd btn-danger" disabled="disabled">
                        <span class="btn-label">
                          <i class="fa fa-circle-o-notch fa-spin"></i>
                        </span>
                        Sign Up!
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright text-center">
              &copy; Copyright 2018 Authentic.net
            </div>
          </div>
        </footer>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <li>
          <router-link to="/scan">
            Scan Code
          </router-link>
        </li>
        <li><a href="https://authentic.net">Authentic.net Home</a></li>
      </ul>
    </div>

  </div>
</template>

<script>
import swal from 'sweetalert2'
import {mapFields} from 'vee-validate'
import firebase from 'firebase'
import { toolboxMixin } from '@/components/mixins/toolboxMixin'

export default {
  computed: {
    ...mapFields(['code'])
  },
  mixins: [toolboxMixin],
  data () {
    return {
      recaptcha: {
        verifier: null,
        confirmationResult: null,
        widgetId: null
      },
      myvariable: 4,
      modelValidations: {
        code: {
          required: true
        }
      },
      loading: false,
      model: {
        code: '',
        clientIpData: null
      }
    }
  },

  methods: {
    async init () {
      this.loading = true
      this.setupRecaptcha()
      // this.model.clientIpData = await this.getClientIpData()
      this.model.clientIp = await this.getClientIp()
      console.log('ip address')
      console.log(this.model.clientIp)
      this.loading = false
    },
    setupRecaptcha () {
      const self = this

      // Start Firebase invisible reCAPTCHA verifier
      this.recaptcha.verifier = new firebase.auth.RecaptchaVerifier('validate-submit', {
        size: 'invisible',
        callback: response => {
          // reCAPTCHA solved, allow to proceed
          console.log('solved ' + response)
          this.validateBeforeSubmit()
        },
        error: () => {
          swal.fire({
            title: 'Error',
            text: 'There was a problem validating captcha',
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          })
        }
      })

      this.recaptcha.verifier.render().then((widgetId) => {
        this.recaptcha.widgetId = widgetId
        // uncomment below if we want to auto submit on page load
        // when a code exists. it doesn't seem to work too well
        // as if the captcha doesn't have a good chance to resolve
        // if (this.model.code !== '') {
        //   let elem = this.$refs.btnSubmit
        //   elem.click()
        // }
      })
    },
    resetRecaptcha () {
      window.grecaptcha.reset(this.recaptcha.widgetId)
      // grecaptcha.reset(this.recaptcha.widgetId)
    },
    toggleNavbar () {
      document.body.classList.toggle('nav-open')
    },
    closeMenu () {
      document.body.classList.remove('nav-open')
      document.body.classList.remove('off-canvas-sidebar')
    },
    handlePriorRegistrationError (authCode) {
      let text = ''
      if (authCode.retailerName !== '') {
        text = 'The Authentic.net Code for this ' + authCode.productName + ' from ' + authCode.retailerName + ' was already registered in the past.'
      } else {
        text = 'The Authentic.net Code for this ' + authCode.productName + ' was already registered in the past.'
      }
      swal.fire({
        title: 'Previously Registered!',
        text: text,
        type: 'warning',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      })
      .then(() => {
        // do nothing until fraud report functionality is fixed
        // this.$router.replace('/fraud-report?code=' + this.model.code)
      })
      this.loading = false
    },
    handleExcessValidationError (authCode) {
      let qtyPriorValidations = authCode.qtyValidations - 1
      let text = ''
      if (authCode.retailerName !== '') {
        text = 'The Authentic.net Code for this ' + authCode.productName + ' from ' + authCode.retailerName + ' was already validated ' + qtyPriorValidations + ' times in the past.'
      } else {
        text = 'The Authentic.net Code for this ' + authCode.productName + ' was already validated ' + qtyPriorValidations + ' times in the past.'
      }
      swal.fire({
        title: 'Previously Validated!',
        text: text,
        type: 'warning',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      })
      .then(() => {
        // do nothing until fraud report functionality is fixed
        // this.$router.replace('/fraud-report?code=' + this.model.code)
      })
      this.loading = false
    },
    handleValidAuthCode (authCode) {
      let text = ''
      if (authCode.retailerName !== '') {
        text = 'Congratulations! This ' + authCode.productName + ' from ' + authCode.retailerName + ' is authentic.'
      } else {
        text = 'Congratulations! This ' + authCode.productName + ' is authentic.'
      }
      let priorValidationQty = authCode.qtyValidations - 1
      if (priorValidationQty > 0) {
        text += ' It has never been registered, but it has been validated ' + priorValidationQty + ' times prior.'
      }
      swal.fire({
        title: `Authentic!`,
        text: text,
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-success btn-fill',
        type: 'success'
      }).then(() => {
        // temporary static conditional redirect when kegelbell account product
        if (authCode.accountId === 'D3zXQmPabbnZY5wEo8rV' && authCode.retailerId === 'T6vlUai6XeGNuH62K5kS') this.$router.replace('/kegelbell-amz?code=' + this.model.code)
        else if (authCode.accountId === 'D3zXQmPabbnZY5wEo8rV' && authCode.retailerId === 'oKi6QqY2UGynFOXhweeD') this.$router.replace('/kegelbell-basic?code=' + this.model.code)
        else if (authCode.accountId === 'D3zXQmPabbnZY5wEo8rV') this.$router.replace('/kegelbell?code=' + this.model.code)
        else if (authCode.accountStatus === 'setup') this.$router.replace({ name: 'Onboarding' })
        else this.$router.replace('/register-code?code=' + this.model.code)
      }).catch(error => {
        console.log(error)
        // temporary static conditional redirect when kegelbell account product
        if (authCode.accountId === 'D3zXQmPabbnZY5wEo8rV' && authCode.retailerId === 'T6vlUai6XeGNuH62K5kS') this.$router.replace('/kegelbell-amz?code=' + this.model.code)
        else if (authCode.accountId === 'D3zXQmPabbnZY5wEo8rV' && authCode.retailerId === 'oKi6QqY2UGynFOXhweeD') this.$router.replace('/kegelbell-basic?code=' + this.model.code)
        else if (authCode.accountId === 'D3zXQmPabbnZY5wEo8rV') this.$router.replace('/kegelbell?code=' + this.model.code)
        else if (authCode.accountStatus === 'setup') this.$router.replace({ name: 'Onboarding' })
        else this.$router.replace('/register-code?code=' + this.model.code)
      })
    },
    submit () {
      let checkCode = firebase.functions().httpsCallable('checkCode')
      checkCode({ code: this.model.code, clientIp: this.model.clientIp, clientIpData: this.model.clientIpData, doNotValidate: false })
      .then(result => {
        console.log(result)
        if (!result.data.valid) {
          swal.fire({
            title: 'Not Authentic!',
            text: 'Sorry! The Authentic.net Code "' + this.model.code + '" Is Invalid.',
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          })
          .then(() => {
            // do nothing until fraud report functionality is fixed
            this.$router.replace('/fraud-report?code=' + this.model.code)
          })
        } else if (result.data.type === 'external') {
          let text = ''
          if (result.data.retailerName !== '') {
            text = 'Congratulations! This ' + result.data.productName + ' from ' + result.data.retailerName + ' is authentic.'
          } else {
            text = 'Congratulations! This ' + result.data.productName + ' is authentic.'
          }
          swal.fire({
            title: `Authentic!`,
            text: text,
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            type: 'success'
          })
        } else { // existing primary code
          console.log(result.data)
          if (result.data.qtyRegistrations !== undefined && result.data.qtyRegistrations > 0) {
            this.handlePriorRegistrationError(result.data)
          } else {
            this.handleValidAuthCode(result.data)
          }
          // else if (result.data.qtyValidations > 2) {
          //   this.handleExcessValidationError(result.data)
          // }
        }
        this.loading = false
      })
      .catch(err => {
        console.error(err.message)
        swal.fire({
          title: 'Not Authentic!',
          text: 'Sorry! The Authentic.net Code "' + this.model.code + '" Is Invalid.',
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        })
        .then(() => {
          // do nothing until fraud report functionality is fixed
          // this.$router.replace('/fraud-report?code=' + this.model.code)
        })
        this.loading = false
      })
    },
    beforeDestroy () {
      this.closeMenu()
    },
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    validateBeforeSubmit () {
      this.loading = true
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.submit()
        } else {
          this.resetRecaptcha()
          this.loading = false
        }
      })
    }
  },

  mounted: function () {
    this.$nextTick(function () {
      if (this.$route.params.code) this.model.code = this.$route.params.code
      else if (this.$route.query.code) this.model.code = this.$route.query.code
      console.log('code: ' + this.model.code)
      // if (this.model.code !== '') this.validateBeforeSubmit()
      this.init()
    })
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Authenticate.vue